import React from "react";
import styled from "styled-components";

const PageHeader = styled.section`
  height: 300px;
  background: linear-gradient(rgba(255, 102, 0, 0.85), rgba(204, 82, 0, 0.85)), url("/images/oth_hdr_bg.webp");
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: center;
  color: white;

  h1 {
    color: white;
    font-size: 3rem;
    text-align: center;
    width: 100%;
  }

  @media (max-width: 768px) {
    height: 200px;
    h1 {
      font-size: 2rem;
    }
  }
`;

const ContentSection = styled.section`
  padding: 80px 0;
  background: #0a0a0a;

  .content-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 4rem;
    align-items: center;
    margin-bottom: 4rem;

    @media (max-width: 768px) {
      grid-template-columns: 1fr;
      gap: 2rem;
    }
  }

  .content-text {
    h2 {
      color: #ff6600;
      margin-bottom: 1.5rem;
    }

    p {
      color: #b0b0b0;
      line-height: 1.8;
      margin-bottom: 1rem;
    }
  }

  .content-image {
    img {
      width: 100%;
      height: auto;
      border-radius: 10px;
      box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
    }
  }
`;

const StatsSection = styled.section`
  padding: 80px 0;
  background: #111;

  .stats-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 2rem;
  }

  .stat-card {
    background: #1a1a1a;
    padding: 2rem;
    text-align: center;
    border-radius: 10px;
    border: 1px solid #333;

    .stat-number {
      font-size: 3rem;
      font-weight: bold;
      color: #ff6600;
      margin-bottom: 0.5rem;
    }

    .stat-label {
      color: #b0b0b0;
      font-weight: 500;
    }
  }
`;

const About = () => {
  const stats = [
    { number: "100+", label: "Happy Customers" },
    { number: "24/7", label: "Service Available" },

    { number: "2+", label: "Years Experience" },
  ];

  return (
    <>
      <PageHeader>
        <div className="container">
          <h1>About Us</h1>
        </div>
      </PageHeader>

      <ContentSection>
        <div className="container">
          <div className="content-grid">
            <div className="content-text">
              <h2>Welcome to Roadwise tyres</h2>
              <p>
                Our competitive advantage is not being tied to any one particular brand. Supporting major tyre brands ensuring constant supply &
                customer choice, with several alternatives achieving the best possible value for any application, Roadwise tyres is well placed to
                assist customers in selecting the right tyre to satisfy all tyre needs.
              </p>
              <p>
                We specialise exclusively in heavy-duty truck tyres and long-haul solutions for prime movers, B-doubles and road trains. Our focus is
                commercial fleets and operators who demand reliability, mileage and proven load ratings.
              </p>
              <p>
                Our experienced team provides depot fitment, fleet management support, and emergency on-road assistance tailored to heavy vehicles.
              </p>
            </div>
            <div className="content-image">
              <img
                src="/images/welc_pic.webp"
                alt="About ATTS"
              />
            </div>
          </div>

          <div className="content-grid">
            <div className="content-image">
              <img
                src="/images/tyre.webp"
                alt="Our Services"
              />
            </div>
            <div className="content-text">
              <h2>Our Mission</h2>
              <p>
                To provide exceptional tyre and truck solutions with unmatched customer service, competitive pricing, and reliable products that keep
                Australia's transport industry moving safely and efficiently.
              </p>
              <h2>Our Vision</h2>
              <p>
                To become Australia's most trusted name in commercial tyre services, known for our expertise, reliability, and commitment to customer
                satisfaction.
              </p>
              <h2>Why Choose Roadwise tyres?</h2>
              <p>
                With our extensive experience, wide range of quality products, and commitment to excellence, we deliver solutions that meet your
                specific needs while providing outstanding value for money.
              </p>
            </div>
          </div>
        </div>
      </ContentSection>

      <StatsSection>
        <div className="container">
          <div className="section-title">
            <h2>Our Achievements</h2>
            <p>Numbers that speak for our commitment to excellence</p>
          </div>

          <div className="stats-grid">
            {stats.map((stat, index) => (
              <div
                key={index}
                className="stat-card">
                <div className="stat-number">{stat.number}</div>
                <div className="stat-label">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </StatsSection>
    </>
  );
};

export default About;
